
import Vue from 'vue';
import { Accordion, Button, Icon } from '@descomplica/vue-components';
import { TabType } from './types';

export default Vue.extend({
  components: {
    Accordion,
    Button,
    Icon,
  },
  computed: {
    valuationItems() {
      const itemsLabel = [
        'clarity',
        'structure',
        'abntRules',
        'language',
        'contents',
        'originality',
        'innovation',
        'present',
        'proposalAdherence',
      ];

      return itemsLabel.map((label) => ({
        title: this.$t(
          `yourAssessments.tcc.tabs.evaluationCriteria.evaluationItems.${label}.title`,
        ),
        contents: this.$t(
          `yourAssessments.tcc.tabs.evaluationCriteria.evaluationItems.${label}.contents`,
        ),
      }));
    },
  },
  methods: {
    goToOrientations() {
      this.$emit('selectTab', TabType.orientations);
    },
    goToTheme() {
      this.$emit('selectTab', TabType.thesisTheme);
    },
  },
});
